import { InformationOutline18Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Spor";

export const CustomWarningText: FC = () => {
  const { t } = useTranslation();
  return (
    <Text
      variant="sm"
      width="100%"
      display="flex"
      gap="6px"
      alignItems="center"
    >
      <InformationOutline18Icon />
      {t("Beskriv hendelsen og årsaken kortfattet og tydelig.")}
    </Text>
  );
};
